import type { VoiceTask } from "@/sdk";
import { CancelPendingCallButton } from "../Buttons/CancelPendingCallButton";

export function PendingCallControls({ task }: { task: VoiceTask }) {
    return <CancelPendingCallButton task={task} />;
}
